export default "<span style=\"color: white\">User is successfully logged in. Redirecting to the main page...</span>";